import React, { FC } from 'react';
import { View } from 'react-native';
import { UseTableColumnsParams } from '@v2/pages/common/components/NCFileBatchEvents/types';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import EventTimeDisplay from '@v2/pages/common/components/NCFileBatchEvents/components/EventTimeDisplay';
import { EventStatusSubStatusExecModeProps } from '@v2/pages/common/components/NCFileBatchEvents/components/EventStatusSubStatusExecMode';

export interface StartTimeCellProps
  extends Pick<UseTableColumnsParams, 'textConfig' | 'eventType' | 'C' | 'font' | 'scale'>,
    Pick<EventStatusSubStatusExecModeProps, 'event'> {}
{
}

const StartTimeCell: FC<StartTimeCellProps> = ({ event, eventType, textConfig, C, scale = initialScale, font = initialFont }) => {
  const startField = textConfig.start?.[eventType]?.(event);

  if (!startField) return null;

  return (
    <View>
      <EventTimeDisplay timeValue={startField ?? 0} C={C} font={font} />
    </View>
  );
};

export default React.memo(StartTimeCell, (prev, next) => {
  return prev.event.sequenceNumber === next.event.sequenceNumber && prev.eventType === next.eventType && prev.C.scheme === next.C.scheme;
});
